import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Modal from "./Modal";
import UpdateModal from "./UpdateModal";
import "./index.css";
import SubmitButtonModal from "./SubmitButtonModal"; // New modal for editing submit button


export default function Builder() {
  const { formId } = useParams(); // formId from URL
  const [parentForm, setParentForm] = useState(null);
  const [fields, setFields] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [sharedId, setSharedId] = useState("");
  const [submitButton, setSubmitButton] = useState({ text: "Submit", color: "#007bff",textColor: "#ffffff" });
  const [showSubmitButtonModal, setShowSubmitButtonModal] = useState(false);


  // Fetch parent form details (company image, name, etc.)
  const fetchParentForm = async () => {
    try {
      const res = await fetch(`https://leadbankapi.gensparc.com/api/submissions/share/${formId}`);
      if (res.ok) {
        const data = await res.json();
        setParentForm(data);
      } else {
        setParentForm(null);
      }
    } catch (error) {
      console.error("Error fetching parent form:", error);
    }
  };

  // Fetch custom fields for the given formId.
  const fetchFields = async () => {
    try {
      const res = await fetch(`https://leadbankapi.gensparc.com/api/fields/${formId}`);
      if (res.ok) {
        const data = await res.json();
        data.sort((a, b) => a.position - b.position);

        setFields(data);
      } else {
        setFields([]);
      }
    } catch (error) {
      console.error("Error fetching fields:", error);
    }
  };

  // Load parent form and fields when component mounts or formId changes.
  useEffect(() => {
    if (formId) {
      fetchParentForm();
      fetchFields();
      fetchSubmitButton();

    }
  }, [formId]);

  const openModal = () => setShowModal(true);
  const [showModal, setShowModal] = useState(false);
  const openUpdateModal = () => setShowUpdateModal(true);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const closeModal = () => setShowModal(false);
  const closeUpdateModal = () => setShowUpdateModal(false);

  // When a new field is added, re-fetch fields.
  const addField = async (fieldData) => {
    await fetchFields();
    setSelectedIndex(null);
  };

  // Remove selected field.
  const removeField = async () => {
    if (selectedIndex === null) return;
    const fieldToRemove = fields[selectedIndex];

    try {
      const res = await fetch(`https://leadbankapi.gensparc.com/api/fields/${formId}/fields/${fieldToRemove.id}`, {
        method: "DELETE",
      });

      if (res.ok) {
        await fetchFields();
        setSelectedIndex(null);
      } else {
        console.error("Failed to remove field");
      }
    } catch (error) {
      console.error("Error removing field:", error);
    }
  };

  // Update selected field.
  const updateField = async (updatedField) => {
    try {
      const res = await fetch(`https://leadbankapi.gensparc.com/api/fields/${formId}/fields/${updatedField.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedField),
      });

      if (res.ok) {
        await fetchFields();
        closeUpdateModal();
      } else {
        console.error("Failed to update field");
      }
    } catch (error) {
      console.error("Error updating field:", error);
    }
  };

  const moveFieldUp = async () => {
    if (selectedIndex === null || selectedIndex === 0) return;
    const newFields = [...fields];
  
    // Swap positions
    [newFields[selectedIndex - 1], newFields[selectedIndex]] = [
      newFields[selectedIndex],
      newFields[selectedIndex - 1],
    ];
  
    // Update positions in the database
    await updateFieldPositions(newFields);
  
    setFields(newFields);
    setSelectedIndex(selectedIndex - 1);
  };
  
  const moveFieldDown = async () => {
    if (selectedIndex === null || selectedIndex === fields.length - 1) return;
    const newFields = [...fields];
  
    // Swap positions
    [newFields[selectedIndex], newFields[selectedIndex + 1]] = [
      newFields[selectedIndex + 1],
      newFields[selectedIndex],
    ];
  
    // Update positions in the database
    await updateFieldPositions(newFields);
  
    setFields(newFields);
    setSelectedIndex(selectedIndex + 1);
  };
  
  // Function to update field positions in the backend
  const updateFieldPositions = async (updatedFields) => {
    try {
      const token = localStorage.getItem("token");
      await fetch(`https://leadbankapi.gensparc.com/api/submissions/reorder/${formId}`, {
        method: "PUT",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ fields: updatedFields }),
      });
    } catch (error) {
      console.error("Error updating field order:", error);
    }
  };
  
  const handleRowClick = (index) => {
    setSelectedIndex(index);
  };

  // Share form: store fields in localStorage and set sharedId.
  const shareForm = () => {
    if (fields.length === 0) {
      alert("No fields to share. Please add at least one field.");
      return;
    }
    localStorage.setItem(formId, JSON.stringify(fields));
    setSharedId(formId);
  };
  // Fetch submit button details
  const fetchSubmitButton = async () => {
    try {
      const res = await fetch(`https://leadbankapi.gensparc.com/api/fields/${formId}/submit-button`);
      if (res.ok) {
        const data = await res.json();
        setSubmitButton(data);
      }
    } catch (error) {
      console.error("Error fetching submit button:", error);
    }
  };

  // Update submit button settings
  const updateSubmitButton = async (updatedButton) => {
    try {
      await fetch(`https://leadbankapi.gensparc.com/api/fields/${formId}/submit-button`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedButton),
      });
      setSubmitButton(updatedButton);
      setShowSubmitButtonModal(false);
    } catch (error) {
      console.error("Error updating submit button:", error);
    }
  };

  return (

    
    <div className="app-container">
{/* edit button style */}

<div className="app">
      {parentForm && (
        <div className="parent-form-details">
          <h1>{parentForm.name}</h1>
          {parentForm.company_image && (
            <img src={`https://leadbankapi.gensparc.com${parentForm.company_image}`} alt="Company" className="company-img" />
          )}
        </div>
      )}

      <div className="action-buttons">
        <button className="btn" onClick={() => setShowSubmitButtonModal(true)}>
          Edit Submit Button
        </button>
      </div>

      <SubmitButtonModal
        show={showSubmitButtonModal}
        onClose={() => setShowSubmitButtonModal(false)}
        onSave={updateSubmitButton}
        submitButton={submitButton}
      />
    </div>
      <div className="action-buttons">
        <button className="btn open-modal" onClick={() => setShowModal(true)}>
          + Add Custom Field
        </button>
        <button className="btn remove-btn" onClick={removeField} disabled={selectedIndex === null}>
          Remove Field
        </button>
        <button className="btn update-btn" onClick={openUpdateModal} disabled={selectedIndex === null}>
          Update Field
        </button>
        <button className="btn action-btn" onClick={moveFieldUp} disabled={selectedIndex === null || selectedIndex === 0}>
          Move Up
        </button>
        <button className="btn action-btn" onClick={moveFieldDown} disabled={selectedIndex === null || selectedIndex === fields.length - 1}>
          Move Down
        </button>
        <button className="btn share-btn" onClick={shareForm}>
          Share
        </button>
      </div>

      {sharedId && (
        <div className="share-link">
          <p>
            Share this link: <Link to={`/form/${sharedId}`}>Open Shared Form</Link>
          </p>
        </div>
      )}

      <Modal show={showModal} onClose={() => setShowModal(false)} onSubmit={addField} formId={formId} />
      {selectedIndex !== null && (
        <UpdateModal
          show={showUpdateModal}
          onClose={() => setShowUpdateModal(false)}
          onUpdate={updateField}
          fieldData={fields[selectedIndex]}
        />
      )}

      <div className="fields-display">
        {fields.length > 0 ? (
          <table className="fields-table">
            <thead>
              <tr>
                <th>Field Type</th>
                <th>Label</th>
                <th>Required</th>
                <th>Options</th>
              </tr>
            </thead>
            <tbody>
              {fields.map((field, index) => (
                <tr
                  key={field.id || index}
                  className={selectedIndex === index ? "selected" : ""}
                  onClick={() => handleRowClick(index)}
                >
                  <td>{field.field_type}</td>
                  <td>{field.label}</td>
                  <td>{field.required ? "Yes" : "No"}</td>
                  <td>{field.field_type === "dropdown" ? JSON.parse(field.options).join(", ") : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No custom fields added yet.</p>
        )}
      </div>
    </div>

    
  );

  
}
